<div class="search-input"
     @fadeSlideInOut *ngIf="slidedIn" >
  <morva-icons *ngIf="expandable" icon="close" class="gray-icon" (click)="clearSearchKey()"></morva-icons>
  <input
    data-testid="universal-search-input"
    fullWidth
    type="text" autocomplete="off"
    id="search-input"
    fieldSize="small"
    placeholder="جستجو در داشبوردها و منابع داده"
    nbInput
    #input
    (focusout)="onFocusOut($event)"
    (focus)="onFocusIn($event)"
  />
  <morva-icons tabindex="0" icon="search" class="universal-search-icons ms-3" #searchIcon></morva-icons>
</div>
<div *ngIf="showResult" @openClose class="search-result pt-3"
     [style.top.px]="top"
     [style.left.px]="left"
>
  <div class="num px-3 mb-2">
    <p class="m-0">نتیجه جستجو: {{searchResult.length}}</p>
  </div>
  <div class="search-results-list" id="search-result">
    <a (click)="clearSearchKey()"
       [routerLink]="asset.assetType === 'DataSource' ?  ['/datasource', asset.workspaceId,asset.assetId] :
       (asset.assetType === 'Dashboard' ? ['/dashboard/view', asset.workspaceId, asset.assetId] : ['/home/dashboardGroup', asset.workspaceId, asset.assetId]) " data-testid="search-resault" class="searchResultItem d-flex align-items-start p-3 pb-2" *ngFor="let asset of searchResult">
      <div class="ms-3">
        <morva-icons class="universal-search-icons" [icon]="asset.assetType === 'DataSource' ? 'dataSource' : (asset.assetType === 'Dashboard' ? 'dashboard' : 'dashboardGroup')"></morva-icons>
      </div>
      <div>
        <h6 class="m-0">
          {{asset.name}}
        </h6>
      </div>
    </a>
  </div>
  <div *ngIf="searchResult.length === 0" class="mx-auto p-5 d-flex justify-content-center align-items-center flex-column">
    <div class="no-data" >
      <img src="/assets/images/not-found-result.png" alt="نتیجه‌ای یافت نشد." />
    </div>
    <div class="no-data-text" >
      <p>نتیجه‌ای یافت نشد.</p>
    </div>
  </div>
</div>
